'use strict';

angular.module('clientDashboardApp').factory('stringService', () => {


  const invalidFieldString = "Invalid fields.  Please complete form.";

  const adminStrings = {
    create : {
      titleAction : "Add",
      successAction : "added",
      actionButtonValue : "Save",
      errorAction : "saving",
      pendingAction : "saving",
      invalidFields :  invalidFieldString
    },
    edit : {
      titleAction : "Edit",
      successAction : "updated",
      actionButtonValue : "Save Changes",
      errorAction : "updating",
      pendingAction : "updating",
      invalidFields : invalidFieldString
    },
    delete : {
      titleAction : "Remove",
      successAction : "removed",
      actionButtonValue : "Save Changes",
      errorAction : "removing",
      pendingAction : "removing",
      invalidFields : invalidFieldString
    },
    manage : {
      titleAction : "",
      actionButtonValue : "Save Changes",
      invalidFields : invalidFieldString
    },
    activate : {
      titleAction : "Activate",
      successAction : "activated",
      actionButtonValue : "Save Changes",
      errorAction : "activating",
      pendingAction : "activating",
      invalidFields : invalidFieldString
    },
    deactivate : {
      titleAction : "Deactivate",
      successAction : "deactivated",
      actionButtonValue : "Save Changes",
      errorAction : "deactivating",
      pendingAction : "deactivating",
      invalidFields : invalidFieldString
    }
  }

  return {
    adminStrings(mode) {
      return mode ? adminStrings[mode] : adminStrings
    }
  }

});
